import React from 'react';
import { Badge, Media, PowerList } from '../';
import { DropAlert } from '../powerList/styles';
import { DropContainer, DropIcon, DropTitle, DropLenght, DropPermaTitle, CloseIcon } from './styles';

export default ({
  badge,
  color,
  theme,
  dataCy,
  mHeigth,
  onClick,
  firstActve,
  permaTitle,
  colorBadge,
  picture = '',
  handleStatus,
  primaryTitle,
  visibleLenght,
  search = true,
  dataArray = [],
  mWidth = 'auto',
  status = false,
  mPadding = '10px 0 10px 10px',
  membershipInfo,
  membershipCount,
  disabled = false,
  isEnrolled = false,
}: {
  onClick: any;
  theme?: string;
  badge?: string;
  color?: string;
  mWidth?: string;
  dataCy?: string;
  search?: boolean;
  picture?: string;
  status?: boolean;
  mHeigth?: string;
  mPadding?: string;
  permaTitle?: string;
  colorBadge?: string;
  firstActve?: boolean;
  primaryTitle?: string;
  visibleLenght?: number;
  handleStatus?: () => void;
  dataArray?: Array<any>;
  membershipInfo?: any;
  membershipCount?: any;
  disabled?: boolean;
  isEnrolled?: boolean;
}) => (
  <DropContainer disabled={disabled} mWidth={mWidth} mPadding={mPadding} data-cy={dataCy}>
    {picture ? (
      <Media imgUrl={picture} size="30px" mRight="0" />
    ) : badge === 'ALL' ? (
      <Badge color="#007AFF" />
    ) : badge ? (
      <Badge text={badge} color={colorBadge} />
    ) : (
      <></>
    )}
    {permaTitle && <DropPermaTitle theme={theme}>{permaTitle}</DropPermaTitle>}
    {color ? (
      <DropAlert color={color}>{primaryTitle}</DropAlert>
    ) : (
      primaryTitle && (
        <DropTitle theme={theme} firstActve={firstActve}>
          {primaryTitle}
        </DropTitle>
      )
    )}
    {visibleLenght && <DropLenght>({visibleLenght})</DropLenght>}
    {status && (dataArray[0]?.title || dataArray[0]?.name || dataArray[0]?.fullName) !== primaryTitle ? (
      <CloseIcon onClick={handleStatus} />
    ) : (
      <DropIcon theme={theme} />
    )}

    <PowerList
      data={dataArray}
      search={search}
      onClick={onClick}
      mHeigth={mHeigth}
      checked={colorBadge}
      membershipInfo={membershipInfo}
      isEnrolled={isEnrolled}
      membershipCount={membershipCount} />
  </DropContainer>
);
